const {h, render, Component} = require('preact');
const Helper = require('../../../helper')
const PhoneNumberInputView = require('../../views/click2call/phone_number_view')
const Click2CallSubmitView = require('../../views/click2call/create_ticket_submit_button_view')
const Click2CallCommentsView = require('../../views/click2call/comments_view')
const LanguageDropdownInputView = require('../../views/click2call/language_dropdown_view')
const {route} = require('preact-router')
const RecaptchaView = require('../../containers/common/recaptcha')
const UserNameInputView = require('../../views/common/user_name_view')
const EmailAddressInputView = require('../../views/common/email_address_view')
const CallbackTime = require('./callback_time')
const FileInputView = require('../../views/email_form/common/file_input')

class Click2CallFormMainView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone_number_box: '',
      phone_number_box_isValid: false,
      locale_value: 'en_US',
      locale_value_isValid: true,
      comment_box: '',
      email_address_box: '',
      email_address_box_isValid: false,
      user_name_box: '',
      user_name_box_isValid: false,
      file_input: null,
      file_input_isValid:false
    };
    this.changePhoneBoxState = this.changePhoneBoxState.bind(this);
    this.changeLanguageBoxState = this.changeLanguageBoxState.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.setReasonText = this.setReasonText.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.setRecaptchaInstance = this.setRecaptchaInstance.bind(this);
    this.changeCommentBoxState = this.changeCommentBoxState.bind(this);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this);
    this.onRecaptchaDone = this.onRecaptchaDone.bind(this);
    this.changeEmailAddressBoxStateClick2Call = this.changeEmailAddressBoxStateClick2Call.bind(this);
    this.changeUserNameBoxStateClick2Call = this.changeUserNameBoxStateClick2Call.bind(this);
    this.validateClickToCallForm = this.validateClickToCallForm.bind(this);
    this.renderSuccess = this.renderSuccess.bind(this);
    this.renderError = this.renderError.bind(this);
    this.changeFileUpload = this.changeFileUpload.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  changeFileUpload(data, name, isValid){
    this.setState({
      file_input: data,
      file_input_isValid : isValid,
      file_name: name
    }, () => this.validateClickToCallForm() );
  }

  changePhoneBoxState(data, isValid) {
    this.setState({
      phone_number_box: data,
      phone_number_box_isValid: isValid
    }, () => this.validateClickToCallForm() );
  }

  componentDidMount(){
    if (this.props.resetState) {
      var clickToCallForm = document.getElementById("form-click2call");
      if (clickToCallForm)
        clickToCallForm.reset();
    }
    this.validateClickToCallForm();
  }

  changeCommentBoxState(data) {
    this.setState({
      comment_box: data
    })
  }

  changeEmailAddressBoxStateClick2Call(data, isValid) {
    this.setState({
      email_address_box: data,
      email_address_box_isValid: isValid
    }, () => this.validateClickToCallForm() );
  }

  changeUserNameBoxStateClick2Call(data, isValid) {
    this.setState({
      user_name_box: data,
      user_name_box_isValid: isValid
    }, () => this.validateClickToCallForm());
  }

  changeLanguageBoxState(data, isValid) {
    this.setState({
      locale_value: data,
      locale_value_isValid: isValid
    })
  }


  validateClickToCallForm() {
    if (this.isRequiredInputGiven()) {
      this.enableSubmitClick2Call();
    }
    else {
      this.disableSubmitClick2Call();
    }
  }

  setRecaptchaInstance (recaptchaInstance) {
    this.recaptchaInstance = recaptchaInstance
  }

  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }

  isRequiredInputGiven() {
    if (this.state.phone_number_box_isValid && this.state.locale_value_isValid) {
      if (!(this.props.contactChannelParams.selectedItem) && (this.getUserLoggedIn() == null)) {
          return (this.state.email_address_box_isValid && this.state.user_name_box_isValid)
      }
      return true;
    }
    return false;
  }

  onRecaptchaDone(instance, response) {
    if (instance) {
      if (response) {
        let that = this;
        this.setState({'recaptcha': true, 'g-recaptcha-response': response}, () => {
          let data = that.getFormData()
          that.submitForm(data)
        });
      }
      else
        this.setState({'recaptcha': false})
    }
    else
      this.setState({'recaptcha': true})
  }

  onSubmitClick() {
    this.disableSubmitClick2Call()
    if (this.isRequiredInputGiven()) {
      if (this.configFromDom.isRecaptchaEnabled)
        this.recaptchaInstance.execute()
      else {
        let data = this.getFormData()
        this.submitForm(data)
      }
    }
    else {
      this.validateClickToCallForm()
    }
  }

  getFormData() {
    let data = this.setReasonText()
    var isGuestCheckoutFlow = this.props.guestOrder
    if(isGuestCheckoutFlow) {
      data.order_id = this.props.guestOrder.orderId
      data.isGuestCheckoutFlow = true
    }
    data = Helper.getBasicTicketData(data, this.props.contactChannelParams.selectedItem)
    let formdata = this.collectInputFromComponents()
    Object.assign(data, formdata)
    if (this.props.contactChannelParams.selectedItem) {
      if (this.props.contactChannelParams.selectedItem.claim_id) {
        let claimData = Helper.getClaimInfo(this.props.contactChannelParams.selectedItem)
        Object.assign(data, claimData)
      }
    }
    return data;
  }

  collectInputFromComponents() {
    var data = {};
    var user = this.getUserLoggedIn();

    data.description = "\n\n" + I18n.translate('js.modules.web_2018.phone_text') + ":" + this.state.phone_number_box + "\n\n"
                        +  I18n.translate('js.modules.web_2018.language_text') + ":" + this.state.locale_value + "\n\n" + I18n.translate('js.modules.web_2018.comments_text') + ":" + this.state.comment_box;
    data.locale = this.state.locale_value;
    data.user_given_phone = this.state.phone_number_box;
    data['g-recaptcha-response'] = this.state['g-recaptcha-response']

    if (user) {
      data.user_name = user.firstName;
      data.user_email = user.email;
    }
    else if (!(this.props.contactChannelParams.selectedItem)) {
      data.user_name = this.state.user_name_box;
      data.user_email = this.state.email_address_box;
    }
    data.fileData = this.state.file_input
    data.fileName = this.state.file_name
    return data;
  }

  enableSubmitClick2Call() {
    var submitButton = document.getElementsByClassName('submit-button-click-to-call btn')[0];
    if (submitButton)
      submitButton.removeAttribute("disabled")
  }

  disableSubmitClick2Call() {
    var submitButton = document.getElementsByClassName('submit-button-click-to-call btn')[0];
    if (submitButton)
      submitButton.setAttribute('disabled', true)
  }

  submitForm(data) {
    Helper.createCallbackTicket(data, this.props.contactChannelParams.selectedItem, this.renderSuccess, this.renderError)
  }

  setReasonText() {
    return Helper.setReasonText(this.props.contactChannelParams)
  }

  resetFormState() {
    var clickToCallForm = document.getElementById("form-click2call");
    if (clickToCallForm)
      clickToCallForm.reset();
  }

  renderSuccess() {
    let waitTime = $('.time-in-bold')[0].innerText;
    this.resetFormState()
    route(`/customer_support/web/thank_you?channel=phone&waitTime=${waitTime}`);
  }

  renderError() {
    this.resetFormState()
    route(`/customer_support/web/error`);
  }

  handleClosePopupEvent() {
    this.setState({'recaptcha': false}, () => this.props.handleClick());
  }

  render() {
    var data = this.setReasonText();
    var orderSelected = this.props.contactChannelParams.selectedItem;
    var isClaims = false;
    var isGuestCheckoutFlow = this.props.guestOrder
    var guestDetails = {}
    if(isGuestCheckoutFlow) {
      guestDetails = {
        userName: 'Guest User',
        emailId: this.props.guestOrder.emailId,
        orderId: this.props.guestOrder.orderId
      }
    }
    var UserLoggedIn = this.getUserLoggedIn();

    var callbackTimeComponent = <CallbackTime
                                locale = {this.state.locale_value}
                                selectedItem = {this.props.contactChannelParams.selectedItem}
                              />


    if (orderSelected){
      isClaims = this.props.contactChannelParams.selectedItem.claim_id;
    }

    if (UserLoggedIn || orderSelected) {
      return (
        <form id="form-click2call">
          <div class="click2call-form">
            <div>
              <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
            </div>
            <h3 class="talk-to-groupon">
              {I18n.translate('js.modules.support.talk_to_us')}
            </h3>
            <div class="fill-out-your-inform">
              {I18n.translate('js.modules.web_2018.fill_out_inform')}{I18n.translate('js.modules.shared.call_us_available')} {I18n.translate('js.modules.shared.call_us_time')}
              {this.configFromDom.attachmentEnabled && I18n.translate('js.modules.web_2018.callback_form_attachment_text')}
            </div>
            <div>
              <PhoneNumberInputView  changePhoneBoxState={this.changePhoneBoxState}/>
              <LanguageDropdownInputView  changeLanguageBoxState={this.changeLanguageBoxState}/>
              {this.configFromDom.attachmentEnabled && <FileInputView changeFileUploadState= {this.changeFileUpload}/>}
              <Click2CallCommentsView  changeCommentBoxState={this.changeCommentBoxState}/>
              <div className="fill-out-your-inform">{I18n.translate('js.modules.web_2018.c2c_disclaimer')}</div>
              {this.configFromDom.isRecaptchaEnabled && <RecaptchaView setRecaptchaInstance={this.setRecaptchaInstance} onRecaptchaDone={this.onRecaptchaDone}/>}
              {callbackTimeComponent}
              <Click2CallSubmitView  onSubmitClick={this.onSubmitClick}/>
            </div>
          </div>
        </form>
      )
    }
    else {
        return (
          <form id="form-click2call">
            <div class="click2call-form-not-logged-in">
              <div>
                <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
              </div>
                <h3 class="talk-to-groupon">
                  {I18n.translate('js.modules.support.talk_to_us')}
                </h3>
              <div class="fill-out-your-inform">
                {I18n.translate('js.modules.web_2018.fill_out_inform')}{I18n.translate('js.modules.shared.call_us_available')} {I18n.translate('js.modules.shared.call_us_time')}
                {this.configFromDom.attachmentEnabled && I18n.translate('js.modules.web_2018.callback_form_attachment_text')}
              </div>
              <div>
                <div class="user-email-info">
                  <UserNameInputView changeUserNameBoxState={this.changeUserNameBoxStateClick2Call} guestName={guestDetails.userName}/>
                  <EmailAddressInputView changeEmailAddressBoxState={this.changeEmailAddressBoxStateClick2Call} guestEmail={guestDetails.emailId}/>
                </div>
                <div class="user-email-info">
                  <PhoneNumberInputView  changePhoneBoxState={this.changePhoneBoxState}/>
                  <LanguageDropdownInputView  changeLanguageBoxState={this.changeLanguageBoxState}/>
                </div>
                {this.configFromDom.attachmentEnabled && <FileInputView changeFileUploadState= {this.changeFileUpload}/>}
                <Click2CallCommentsView  changeCommentBoxState={this.changeCommentBoxState}/>
                <div className="fill-out-your-inform">{I18n.translate('js.modules.web_2018.c2c_disclaimer')}</div>
                {this.configFromDom.isRecaptchaEnabled && <RecaptchaView setRecaptchaInstance={this.setRecaptchaInstance} onRecaptchaDone={this.onRecaptchaDone}/>}
                {callbackTimeComponent}
                <Click2CallSubmitView  onSubmitClick={this.onSubmitClick}/>
              </div>
            </div>
          </form>
        )
    }
  }
}

module.exports = Click2CallFormMainView
